<!-- <p-panel [toggleable]="true" [collapsed]="true">
    <ng-template #header>
        <div class="flex items-center">
            <label class="text-600 font-bold">Update Multiple Users</label>
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="flex flex-wrap items-center justify-between gap-4">
            <div class="flex items-center gap-2">
                <button
                    pButton
                    pRipple
                    icon="pi pi-times"
                    severity="danger"
                    text
                    aria-label="Clear Selected"
                    #clearBulkUpdates
                    label="Clear"
                    (click)="bulkUpdate.reset()"
                >
                </button>
                <button
                    #applyBulkUpdates
                    pButton
                    pRipple
                    severity="success"
                    aria-label="Apply Bulk Updates"
                    [disabled]="
                        !updateEnabled
                    "
                    icon="pi pi-check"
                    label="Save"
                    text
                    (click)="
                        UpdateBulkLogins.next(bulkFormGroup.value);
                        bulkFormGroup.reset()
                    "
                ></button>
            </div>
        </div>
    </ng-template>
    <form #bulkUpdate="ngForm" id="bulkUpdate" [formGroup]="bulkFormGroup">
        <div class="grid">
            <div class="col-3">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select
                        class="w-full"
                        inputId="format_label"
                        id="ddldefaultUserIdFormat"
                        [autoDisplayFirst]="false"
                        appendTo="body"
                        [options]="userIdFormats"
                        [filter]="true"
                        #defaultUserIdFormat
                        formControlName="UserIDFormat"
                    >
                    </p-select>
                    <label for="format_label">Default UserId Format</label>
                </p-floatlabel>
            </div>
            <div *ngIf="userInfo?.LegacyPswdReset" class="col-3">
                <input
                    class="w-full"
                    [hidden]="!userInfo?.LegacyPswdReset"
                    placeholder="Default Password"
                    id="defaultPassword"
                    type="password"
                    [required]="defaultUserIdFormat.value"
                    pPassword
                    formControlName="EPassword"
                />
            </div>
            <div class="col-3">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select
                        class="w-full"
                        inputId="holiday_label"
                        appendTo="body"
                        [options]="holidayAuthOptions"
                        [filter]="false"
                        formControlName="AuthorizedHolidays"
                        placeholder="Holiday Auths"
                    >
                    </p-select>
                    <label for="holiday_label">Holiday Auths</label>
                </p-floatlabel>
            </div>
            <div class="col-3">
                <p-floatlabel *ngIf="costCenters && costCenters.length > 1" class="w-full md:w-56" variant="on">
                    <p-select
                        class="w-full"
                        inputId="cc_label"
                        id="ddlbulkCostCenters"
                        appendTo="body"
                        [autoDisplayFirst]="false"
                        [options]="costCenters"
                        [filter]="true"
                        #costCenter
                        formControlName="CostCenterID"
                    >
                    </p-select>
                    <label for="cc_label">Cost Center</label>
                </p-floatlabel>
            </div>
            <div class="col-3">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select
                        class="w-full"
                        inputId="fdow_label"
                        id="ddlbulkDayOfWeek"
                        appendTo="body"
                        [autoDisplayFirst]="false"
                        [options]="daysOfWeek"
                        [filter]="true"
                        #dayOfWeek
                        formControlName="FirstDayofWeekID"
                    >
                    </p-select>
                    <label for="fdow_label">First Day Of Week</label>
                </p-floatlabel>
            </div>
            <div class="col-3">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select
                        class="w-full"
                        inputId="timezone_label"
                        id="ddldefaultTimeZone"
                        appendTo="body"
                        [autoDisplayFirst]="false"
                        [options]="timeZones"
                        [filter]="true"
                        #timezone
                        formControlName="EmpTimeZone"
                    >
                    </p-select>
                    <label for="timezone_label">Time Zone</label>
                </p-floatlabel>
            </div>
            <div class="col-3">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <input
                        inputId="ehpd_label"
                        class="w-full"
                        id="expectedHoursPerDay"
                        type="text"
                        pInputText
                        formControlName="Expectedhrsperday"
                    />
                    <label for="ehpd_label">Expected Hrs Per Day</label>
                </p-floatlabel>
            </div>
            <div class="col-3">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <input
                        inputId="ehpw_label"
                        class="w-full"
                        id="expectedHoursPerWeek"
                        type="text"
                        pInputText
                        formControlName="Expectedhrsperweek"
                    />
                    <label for="ehpw_label">Expected Hrs Per Week</label>
                </p-floatlabel>
            </div>
        </div>
    </form>
</p-panel> -->

<button *ngIf="updateEnabled" pButton pRipple type="button" severity="primary" (click)="showDialog($event)" label="Update Multiple Users"></button>
<p-dialog header="Multi Update" [modal]="true" [(visible)]="visible" [style]="{ width: '25rem' }">
    <span class="p-text-secondary block mb-3">
        Update your information.
        <button
            pButton
            pRipple
            severity="info"
            text
            aria-label="Clear Selected"
            #clearBulkUpdates
            label="Clear"
            (click)="bulkUpdate.reset()"
        >
        </button>
    </span>
    <form #bulkUpdate="ngForm" id="bulkUpdate" [formGroup]="bulkFormGroup" (mousedown)="$event.stopPropagation()">
        <p-floatlabel class="w-full md:w-56 mb-3" variant="on">
            <p-select
                styleClass="w-full"
                inputId="format_label"
                id="ddldefaultUserIdFormat"
                [autoDisplayFirst]="false"
                appendTo="body"
                [options]="userIdFormats"
                [filter]="true"
                #defaultUserIdFormat
                formControlName="UserIDFormat"
            >
            </p-select>
            <label for="format_label">Default UserId Format</label>
        </p-floatlabel>
        <p-floatlabel class="w-full md:w-56 mb-3" variant="on" *ngIf="userInfo?.LegacyPswdReset">
            <input
                inputId="pwd_label"
                class="w-full"
                [hidden]="!userInfo?.LegacyPswdReset"
                id="defaultPassword"
                type="password"
                [required]="defaultUserIdFormat.value"
                pPassword
                formControlName="EPassword"
            />
            <label for="pwd_label">Default Password</label>
        </p-floatlabel>
        <p-floatlabel class="w-full md:w-56 mb-3" variant="on">
            <p-select
                styleClass="w-full"
                inputId="holiday_label"
                appendTo="body"
                [options]="holidayAuthOptions"
                [filter]="false"
                formControlName="AuthorizedHolidays"
            >
            </p-select>
            <label for="holiday_label">Holiday Auths</label>
        </p-floatlabel>
        <p-floatlabel *ngIf="costCenters && costCenters.length > 1" class="w-full md:w-56 mb-3" variant="on">
            <p-select
                styleClass="w-full"
                inputId="cc_label"
                id="ddlbulkCostCenters"
                appendTo="body"
                [autoDisplayFirst]="false"
                [options]="costCenters"
                [filter]="true"
                #costCenter
                formControlName="CostCenterID"
            >
            </p-select>
            <label for="cc_label">Cost Center</label>
        </p-floatlabel>
        <p-floatlabel class="w-full md:w-56 mb-3" variant="on">
            <p-select
                styleClass="w-full"
                inputId="fdow_label"
                id="ddlbulkDayOfWeek"
                appendTo="body"
                [autoDisplayFirst]="false"
                [options]="daysOfWeek"
                [filter]="true"
                #dayOfWeek
                formControlName="FirstDayofWeekID"
            >
            </p-select>
            <label for="fdow_label">First Day Of Week</label>
        </p-floatlabel>
        <p-floatlabel class="w-full md:w-56 mb-3" variant="on">
            <p-select
                styleClass="w-full"
                inputId="timezone_label"
                id="ddldefaultTimeZone"
                appendTo="body"
                [autoDisplayFirst]="false"
                [options]="timeZones"
                [filter]="true"
                #timezone
                formControlName="EmpTimeZone"
            >
            </p-select>
            <label for="timezone_label">Time Zone</label>
        </p-floatlabel>
        <p-floatlabel class="w-full md:w-56 mb-3" variant="on">
            <input
                inputId="ehpd_label"
                class="w-full"
                id="expectedHoursPerDay"
                type="text"
                pInputText
                formControlName="Expectedhrsperday"
            />
            <label for="ehd_label">Expected Hrs Per Day</label>
        </p-floatlabel>
        <p-floatlabel class="w-full md:w-56" variant="on">
            <input
                inputId="ehpw_label"
                class="w-full"
                id="expectedHoursPerWeek"
                type="text"
                pInputText
                formControlName="Expectedhrsperweek"
            />
            <label for="ehw_label">Expected Hrs Per Week</label>
        </p-floatlabel>
    </form>
    <ng-template #footer>
        <button
            #applyBulkUpdates
            pButton
            pRipple
            severity="success"
            aria-label="Apply Bulk Updates"
            [disabled]="
                !updateEnabled
            "
            label="Update"
            text
            (click)="
                UpdateBulkLogins.next(bulkFormGroup.value);
                bulkFormGroup.reset()
            "
        ></button>
    </ng-template>
</p-dialog>

<!-- <div>
    <form #bulkUpdate="ngForm" id="bulkUpdate" [formGroup]="bulkFormGroup">
        <p-toolbar>
            <button
                #applyBulkUpdates
                pButton
                aria-label="Apply Bulk Updates"
                [disabled]="
                    !updateEnabled
                "
                icon="fas fa-pen-square"
                label="Update"
                (click)="
                    UpdateBulkLogins.next(bulkFormGroup.value);
                    bulkFormGroup.reset()
                "
            ></button>
            <div>
                <button
                    class="btn btn-link"
                    aria-label="Clear Selected"
                    #clearBulkUpdates
                    label="Clear"
                    (click)="bulkUpdate.reset()"
                >
                    Clear
                </button>
            </div>
            <p-floatlabel class="w-full md:w-56" variant="on">
                <p-select
                    inputId="on_label"
                    [virtualScroll]="true"
                    itemSize="32"
                    id="ddldefaultUserIdFormat"
                    [autoDisplayFirst]="false"
                    appendTo="body"
                    [options]="userIdFormats"
                    [filter]="true"
                    #defaultUserIdFormat
                    formControlName="UserIDFormat"
                >
                </p-select>
                <label for="on_label">Default UserId Format</label>
            </p-floatlabel>
            <input
                [hidden]="!userInfo?.LegacyPswdReset"
                placeholder="Default Password"
                id="defaultPassword"
                type="password"
                [required]="defaultUserIdFormat.value"
                pPassword
                formControlName="EPassword"
            />
            <p-floatlabel class="w-full md:w-56" variant="on">
                <p-select
                    inputId="on_label"
                    [virtualScroll]="false"
                    itemSize="32"
                    id="ddldefaultUserIdFormat"
                    [autoDisplayFirst]="false"
                    appendTo="body"
                    [options]="holidayAuthOptions"
                    [filter]="false"
                    #defaultUserIdFormat
                    formControlName="AuthorizedHolidays"
                >
                </p-select>
                <label for="on_label">Holiday Auths</label>
            </p-floatlabel>
            <p-floatlabel *ngIf="costCenters && costCenters.length > 1" class="w-full md:w-56" variant="on">
                <p-select
                    inputId="on_label"
                    [style]="{ 'max-width': '10em' }"
                    [virtualScroll]="true"
                    itemSize="32"
                    id="ddlbulkCostCenters"
                    appendTo="body"
                    [autoDisplayFirst]="false"
                    [options]="costCenters"
                    [filter]="true"
                    #costCenter
                    formControlName="CostCenterID"
                >
                </p-select>
                <label for="on_label">Cost Center</label>
            </p-floatlabel>
            <p-floatlabel class="w-full md:w-56" variant="on">
                <p-select
                    inputId="on_label"
                    [style]="{ 'max-width': '12em' }"
                    [virtualScroll]="true"
                    itemSize="32"
                    id="ddlbulkDayOfWeek"
                    appendTo="body"
                    [autoDisplayFirst]="false"
                    [options]="daysOfWeek"
                    [filter]="true"
                    #dayOfWeek
                    formControlName="FirstDayofWeekID"
                >
                </p-select>
                <label for="on_label">First Day Of Week</label>
            </p-floatlabel>
            <p-floatlabel class="w-full md:w-56" variant="on">
                <p-select
                    inputId="on_label"
                    [style]="{ 'max-width': '10em' }"
                    [virtualScroll]="true"
                    itemSize="32"
                    id="ddldefaultTimeZone"
                    appendTo="body"
                    [autoDisplayFirst]="false"
                    [options]="timeZones"
                    [filter]="true"
                    #timezone
                    formControlName="EmpTimeZone"
                >
                </p-select>
                <label for="on_label">Time Zone</label>
            </p-floatlabel>

            <input
                style="max-width: 12em"
                placeholder="Expected Hrs Per Day"
                id="expectedHoursPerDay"
                type="text"
                pInputText
                formControlName="Expectedhrsperday"
            />
            <input
                style="max-width: 12em"
                placeholder="Expected Hrs Per Week"
                id="expectedHoursPerWeek"
                type="text"
                pInputText
                formControlName="Expectedhrsperweek"
            />
        </p-toolbar>
        <p-toolbar>
            <button
                #applyBulkUpdates
                pButton
                aria-label="Apply Bulk Updates"
                [disabled]="
                    !updateEnabled
                "
                icon="fas fa-pen-square"
                label="Update"
                (click)="
                    UpdateBulkLogins.next(bulkFormGroup.value);
                    bulkFormGroup.reset()
                "
            ></button>
        </p-toolbar>
    </form>
</div> -->
